import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from "@angular/core";
import {AccountModel} from "../../models/account.model";
import {SiteFiltersType} from "../../../../commons/types/site-filters.type";

require('./demand-account-link.scss');
@Component({
  standalone: false,
  selector: 'app-demand-account-link',
  templateUrl: './demand-account-link.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DemandAccountLinkComponent {

  @Input() account: AccountModel | {id: string, name: string};
  @Input() address: any;
  @Input() phone: string;
  @Input() additionalPhone: string;
  @Input() isAllowCopyButton: boolean;
  @Input() isShowFilterByButton: boolean;
  @Input() isDisableTooltip?: boolean;

  @Output() filterEvent = new EventEmitter<any>();

  public siteFiltersType: typeof SiteFiltersType = SiteFiltersType;
  public isShowActions: boolean = false;

  constructor() {}

  filterByTypeEvent($event) {
    $event.stopPropagation();
    this.filterEvent.emit({type: this.siteFiltersType.accountIds, value: this.account.id});
  }

}
